import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=463b9e9a&"
import script from "./formItemSrc.ts?vue&type=script&lang=js&"
export * from "./formItemSrc.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports